






import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import OrganizerResourceList from '@superUI/ResourceList/OrganizerResourceList'
import CsvExportResourceTriggerModal from '@triggers/Utils/CsvExportResourceTriggerModal'

settings =
  name: 'OrganizerList'
  components: { SuperContainerView, OrganizerResourceList, CsvExportResourceTriggerModal }

  resources:
    organizers:
      resourceName: 'organizers'
      slug: 'organizers'
      infinityScroll: true

  vue:
    methods:
      fetchResource: (state, resourceKey, data = {}, options={}) ->
        @fetchInfinity(state, resourceKey, data, options)

      csvExportResourceTrigger: (payloadOptions) ->
        @$refs.csvExportResourceTrigger.fire(@exportCsvParams("organizers", payloadOptions))

      onOrganizersCsvExport: ->
        @$refs.csvExportResourceTrigger.close()

      onOrganizersCsvExportError: -> @showError('Failed to export csv')

export default VueOptions.vue settings
